<template>
  <div class="wrap">
    <div class="inbox" ref="inboxRef">
      <div class="bg_w">
        <span class="span" style="font-size: 13px;min-width: 70px">{{
            group ? $t('select.user') : $t('common.emailbox.select')
          }}：</span>
        <el-select v-model="selectedTeamId" @change="handleSelectUser" :placeholder="$t('common.email.chooseEmail')"
                   style="margin-right: 10px;font-size: 13px" size="small">
          <el-option
              v-for="item in tableDataSelect"
              :label="item.userName"
              :value="item.userId"
              :key="item.userId"
          />
        </el-select>
        <el-select v-model="selectedFolder" size="small" @change="handleSelectFolder" v-if="group"
                   style="margin-right: 10px;">
          <el-option :label="$t('common.all')" value="all" :key="$t('common.all')"></el-option>
          <el-option
              v-for="item in targetFileList.filter(it=>it.id!=='99999')"
              :label="item.fileName"
              :value="item.id"
              :key="item.id"
          />
        </el-select>
        <el-select v-model="configId" size="small">
          <el-option :label="$t('common.setting.allEmail')" value="all" id="all"/>
          <el-option
              v-for="item in emailList"
              :label="item.label"
              :value="item.value"
              :key="item.value"
          />
        </el-select>
        <div style="flex-grow: 1;"></div>
        <el-input
            v-model="searchCount"
            :placeholder="$t('common.search.p')"
            class="input-with-select"
            clearable
            size="small"
            @clear="handleSearchInput('clear')"
            @keydown.enter.native="handleSearchInput"
        >
          <template #append>
            <ElButton type="primary" size="small" @click="handleSearchInput('search')"
                      style="font-size: 13px !important;">
              {{ $t('common.search') }}
            </ElButton>
          </template>
        </el-input>
        <el-button style="margin-left: 10px;font-size: 13px !important;" @click="drawer = true" size="small">
          {{ $t('common.search.advanced') }}
        </el-button>
      </div>
      <div class="screen">
        <div class="screen_btn">
          <template v-if="type === 1 || type === 3">
            <ElButton size="small" @click="requestTagAllRead">{{ $t('common.read.all') }}</ElButton>
            <ElButton size="small" @click="() => handleCommand(0)">{{ $t('common.read.set') }}</ElButton>
            <ElButton size="small" @click="() => requestDelMail(1,false)">{{ $t('common.delete') }}</ElButton>
            <!-- <ElButton size="small" v-if="type === 1">垃圾邮件</ElButton> -->
          </template>
          <ElButton size="small" v-if="type === 2" @click="() => requestDelMail(1)">{{
              $t('common.draft.delete')
            }}
          </ElButton>
          <ElButton size="small" v-if="type === 1" @click="() => handleBlack()">{{ $t('common.block') }}</ElButton>
          <template v-if="type === 4">
            <ElButton size="small" @click="requestTagAllRead">{{ $t('common.read.all') }}</ElButton>
            <ElButton size="small" @click="() => requestDelMail(2,false)">{{ $t('common.delete.empty') }}</ElButton>
            <ElButton size="small" @click="() => handleBlack()">{{ $t('common.block') }}</ElButton>
            <ElButton size="small" @click="() => requestDelMail(0,false)">{{ $t('common.restore') }}</ElButton>
          </template>
          <ElDropdown size="small" @command="handleCommand">
            <el-button size="small">
              {{ $t('common.mark.to') }}...
            </el-button>
            <template #dropdown>
              <el-dropdown-menu>
                <el-dropdown-item :command="0">{{ $t('common.email.read') }}</el-dropdown-item>
                <el-dropdown-item :command="1">{{ $t('common.email.noread') }}</el-dropdown-item>
                <el-dropdown-item :command="2">{{ $t('common.email.starmark') }}</el-dropdown-item>
                <el-dropdown-item :command="3">{{ $t('common.cancel.mark') }}</el-dropdown-item>
              </el-dropdown-menu>
            </template>
          </ElDropdown>
          <ElDropdown size="small" @command="handleGroupEmail"
                      v-if="(type===1||type===3||type===2||type===4)&&targetFileList.length>0">
            <el-button size="small">
              {{ $t('common.move.to') }}...
            </el-button>
            <template #dropdown>
              <div @scroll="handleScroll" class="dropdown-menu-wrapper"
                   style="max-height: 300px;max-width: 180px; overflow-y: auto;">
                <el-dropdown-menu class="move-select">
                  <el-dropdown-item :command="item.id"
                                    v-for="item in targetFileList.filter(it => it.id !== route.params.folderId)"
                                    :key="item.id">
                    <template v-if="item.id==='99999'">
                      <span style="color: #5e9ff8">{{ item.fileName }}</span>
                    </template>
                    <template v-else>
                      {{ item.fileName }}
                    </template>
                  </el-dropdown-item>
                </el-dropdown-menu>
              </div>
            </template>
          </ElDropdown>
          <el-button size="small" v-else>
            {{ $t('common.move.to') }}...
          </el-button>
        </div>
        <el-pagination
            v-model:current-page="current"
            v-model:page-size="size"
            small="small"
            v-if="total"
            layout="total, prev, pager, next, jumper"
            :total="total"
            @current-change="handleCurrentChange"
        />
      </div>
      <!--      新的移动模块-->
      <div class="Drag2" ref="DragBox">
        <div class="box" ref="box">
          <!--      <div class="left">-->
          <!--        &lt;!&ndash;左侧div内容&ndash;&gt;-->
          <!--      </div>-->
          <!--      <div class="resize" title="左右侧边栏">⋮</div>-->
          <div class="mid">
            <!--右侧div内容-->
            <div class="topBox" :style="{height:inboxTop+'px'}">
              <!--右上div内容-->
              <ElTable v-loading="loading"
                       :data="tableData"
                       row-key="id"
                       @selection-change="handleSelectionChange"
                       size="small"
                       highlight-current-row
                       ref="tableRef"
                       id="sp_tables"
                       :style="{width:'100vw'}"
                       :height="'100%'"
                       @current-change="handleCurrentRowChange"
                       :row-class-name="tableRowClassName"
                       @sort-change="sort_change"
                       :cell-style="rowClassName"
                       :header-cell-style="headerClassName"
                       :row-style="{height: '30px'}"
                       @cell-mouse-enter="mouseEnters"
                       @cell-mouse-leave="mouseLeaves"
                       @row-dblclick="handleViewDetail"
              >
                <el-table-column type="selection" width="30" fixed="left"/>
                <el-table-column width="20" prop="isStress" sortable="custom"
                                 class-name="sort_ps"
                >
                  <template #header>
                    <img style="position: absolute;left: 1px;top: 9px;" src="../../../assets/email/hp.svg"/>
                  </template>
                  <template #default="scope">
                    <img v-if="scope.row.isStress === 1" @click.stop="() => handleSettingStress(scope, 3)"
                         class="pointer flags_f"
                         src="../../../assets/email/hp.svg"/>
                    <img v-else class="pointer flags_f" @click.stop="() => handleSettingStress(scope, 2)"
                         src="../../../assets/email/hp1.svg"/>
                  </template>
                </el-table-column>
                <el-table-column width="30" prop="isRead" sortable="custom" class-name="sort_ps">
                  <template #header>
                    <img style="position: absolute;left: 8px;top: 9px;" src="../../../assets/email/weidu.svg"/>
                  </template>
                  <template #default="scope">
                    <img style="position: absolute;left: 8px;top: 6px" v-if="scope.row.isRead === 1"
                         @click.stop="() => handleSetRead(scope)" class="pointer"
                         src="../../../assets/email/yidu.svg"/>
                    <img style="position: absolute;left: 8px;top:9px" v-else class="pointer"
                         @click.stop="() => handleSetRead(scope)"
                         src="../../../assets/email/weidu.svg"/>
                  </template>
                </el-table-column>
                <el-table-column width="20" prop="fj" sortable="custom" class-name="sort_ps">
                  <template #header>
                    <img style="position: absolute;left: 6px;top:9px" src="../../../assets/email/fj.svg"/>
                  </template>
                  <template #default="scope">
                    <img style="position: absolute;left: 6px;top:9px" v-if="scope.row.isExtend === 1" class="pointer"
                         src="../../../assets/email/fj.svg"
                         @click.stop="() => handleDownload(scope)"/>
                  </template>
                </el-table-column>
                <el-table-column width="30" prop="reply" sortable="custom" class-name="sort_ps"
                                 v-if="type===1||type===3">
                  <template #default="{row}">
                    <img v-if="row.isReply===1&&type===1" style="position: absolute;left:6px;top:8px" height="14"
                         src="../../../assets/email/rp2.png">
                    <img v-else-if="row.isAnswer===1&&type===3" style="position: absolute;left:6px;top:8px" height="14"
                         src="../../../assets/email/rp1.png">
                  </template>
                </el-table-column>
                <el-table-column
                    prop="from"
                    :label="type !== 1 && type !== 4 ? $t('common.email.to') : $t('common.email.from')"
                    width="265"
                >
                  <template #default="scope">
                    <!-- 类型为 1 或 4 -->
                    <template v-if="type === 1 || type === 4">
                      <el-popover
                          v-if="(scope.row.customerName != null || scope.row.contactEmail != null) && scope.row.onclick"
                          :width="'max-content'"
                          effect="dark"
                          trigger="hover"
                          :show-after="1200"
                          :content="scope.row.contactEmail != null ? scope.row.contactEmail : scope.row.customerName + '(' + scope.row.companyEmail + ')'"
                      >
                        <template #reference>
                          <div v-if="scope.row.customerName != null"
                               @click="handleClickToLinkCustomerDetail(scope.row.customerId)">
                            <OverflowTooltip
                                :content="scope.row.customerName"
                                :show-after="1200"
                                style="color: #0087ff; max-width: 100%;"
                            >
                              <span style="color: #0087ff"
                                    v-html="highlightKeyword(scope.row.customerName, searchCount)"></span>
                            </OverflowTooltip>
                          </div>
                          <span v-else>
                        <OverflowTooltip
                            :content="scope.row.from"
                            :show-after="1200"
                        >
                          <span
                              v-html="highlightKeyword(
                              scope.row.flag === 1
                                ? scope.row.from
                                : scope.row.customerName != null
                                ? scope.row.customerName
                                : scope.row.contactName != null
                                ? scope.row.contactName
                                : scope.row.from,
                              searchCount
                            )"
                          ></span>
                        </OverflowTooltip>
                       </span>
                        </template>
                      </el-popover>
                      <span v-else>
                      <OverflowTooltip
                          :content="scope.row.from"
                          :show-after="1200"
                      >
                        <span
                            v-html="highlightKeyword(
                            scope.row.flag === 1
                              ? scope.row.from
                              : scope.row.customerName != null
                              ? scope.row.customerName
                              : scope.row.contactName != null
                              ? scope.row.contactName
                              : scope.row.from,
                            searchCount
                          )"
                        ></span>
                      </OverflowTooltip>
                    </span>
                    </template>
                    <!-- 非 type 1 和 4 -->
                    <template v-else>
                      <el-popover
                          v-if="scope.row.customerName !== null && scope.row.onclick"
                          placement="right"
                          :width="'max-content'"
                          effect="dark"
                          trigger="hover"
                          :show-after="1200"
                          :content="scope.row.contactEmail != null ? scope.row.contactEmail : scope.row.customerName + '(' + scope.row.companyEmail + ')'"
                      >
                        <template #reference>
                          <div @click="handleClickToLinkCustomerDetail(scope.row.customerId)">
                            <OverflowTooltip
                                :content="scope.row.customerName"
                                :show-after="1200"
                                style="color: #0087ff; max-width: 100%;"
                            >
                              <span style="color: #0087ff;"
                                    v-html="highlightKeyword(scope.row.customerName, searchCount)"></span>
                            </OverflowTooltip>
                          </div>
                        </template>
                      </el-popover>
                      <template v-else>
                        <template v-if="scope.row.mailRecipientList && scope.row.mailRecipientList.length > 1">
                          <el-popover
                              placement="right"
                              :width="'max-content'"
                              effect="dark"
                              trigger="hover"
                              :show-after="1200"
                              :content="scope.row.mailRecipientList.join(' , ')"
                          >
                            <template #reference>
                              <OverflowTooltip
                                  :content="scope.row.mailRecipientList[0] + '...'"
                                  :show-after="1200"
                              >
                                <span
                                    v-html="highlightKeyword(`${scope.row.mailRecipientList[0]} ...`, searchCount)"></span>
                              </OverflowTooltip>
                            </template>
                          </el-popover>
                        </template>
                        <template v-else>
                          <OverflowTooltip
                              :content="scope.row.customerName || (scope.row.mailRecipientList ? scope.row.mailRecipientList[0] : '')"
                              :show-after="1200"
                          >
                              <span
                                  v-html="highlightKeyword(
                                  scope.row.customerName
                                    ? scope.row.customerName
                                    : scope.row.mailRecipientList
                                    ? scope.row.mailRecipientList[0]
                                    : '',
                                  searchCount
                                )"
                              ></span>
                          </OverflowTooltip>
                        </template>
                      </template>
                    </template>
                  </template>
                </el-table-column>
                <el-table-column width="18">
                  <template #default="scope">
                    <img
                        v-if="scope.row.urgent === 1"
                        src="../../../assets/svg/warning.svg"
                        class="urgent-icon"
                    />
                  </template>
                </el-table-column>
                <el-table-column prop="subject" :label="$t('common.subject')">
                  <template #default="scope">
                    <!-- 紧急图标 -->
                    <div
                        class="subject-cell"
                        style="display: flex; align-items: center; position: relative;"
                    >
                      <!-- 内容部分，是否溢出决定是否显示 tooltip -->
                      <OverflowTooltip
                          :content="scope.row.subject"
                          :show-after="1200"
                      >
                        <a
                            @click.stop="handleViewDetail(scope.row)"
                            class="subject-text"
                        >
                          <span
                              v-html="highlightKeyword(scope.row.subject, searchCount)"></span>
                        </a>
                      </OverflowTooltip>
                    </div>
                  </template>
                </el-table-column>
                <el-table-column
                    prop="sendTime"
                    class-name="sort_ps"
                    sortable="custom" :label="$t('common.date')"
                    width="140">
                  <template #default="{row}">
                    <span v-if="row.sendTime!=null">{{ row.sendTime }}</span>
                    <span v-else-if="row.sentDate!==null">{{ row.sentDate }}</span>
                    <span v-else>{{ row.createTime }}</span>
                  </template>
                </el-table-column>
                <el-table-column prop="remark" :label="$t('common.remark')" width="80">
                  <template #default="scope">
                    <div class="flex">
                      <!--                         @click.stop="handleRef(refMap[`${scope.row.id}`], scope.row, 1)"-->
                      <el-icon :ref="(el) => (refMap[`${scope.row.id}`] = el)"
                               @click.stop="handleClickRemark(scope.row)"
                               :color="scope.row.remark ? '#40a9ff' : '#dddddd'" style="padding-top: -2px">
                        <el-tooltip
                            v-if="emailListCheckoutTarget.remark"
                            class="box-item"
                            :content="emailListCheckoutTarget.remark"
                            placement="right"
                            :show-after="1200"
                        >
                          <Memo/>
                        </el-tooltip>
                        <Memo v-else/>
                      </el-icon>
                    </div>
                  </template>
                </el-table-column>
                <el-table-column v-if="type===3" prop="isAnswer" :label="$t('common.email.list.isAnswer')"
                                 :width="flexWidth('isAnswer', tableData, $t('common.email.list.isAnswer'))">
                  <template #default="{row}">
                    <template v-if="row.isAnswer ===1">
                      <el-button class="btn_reset" link type="success" size="small">{{ $t('common.email.status1') }}
                      </el-button>
                    </template>
                    <template v-else-if="row.isAnswer===0">
                      <el-button class="btn_reset" link type="warning" size="small">{{ $t('common.email.status2') }}
                      </el-button>
                    </template>
                  </template>
                </el-table-column>
                <el-table-column v-if="type===3" prop="isTrack" :label="$t('common.isreading')"
                                 :width="flexWidth('isTrack', tableData, $t('common.isreading'))">
                  <template #default="{row}">
                    <template v-if="row.isTrack===1">
                      <div :ref="(el) => (refMap[`${row.id}_isTrack`] = el)"
                           class="flex">
                        <img
                            @mouseover="handleRef(refMap[`${row.id}_isTrack`], row, 2)" style="cursor: pointer"
                            src="../../../assets/img/email/quanbuyidu.png" height="15"/>
                      </div>
                    </template>
                    <template v-else-if="row.isTrack===0"></template>
                  </template>
                </el-table-column>
                <el-table-column prop="originalPosition" :label="$t('common.location')" v-if="type === 4"
                                 :width="lang!=='zh-CN'?120:80">
                  <template #default="{row}">
                    {{
                      row.originalPosition === 1 ? $t('common.emailbox.receive') : row.originalPosition === 3 ? $t('common.has.sent') : row.originalPosition === 2 ? $t('common.draftsbox') : row.originalPosition === 4 ? $t('common.dustbin') : ''
                    }}
                  </template>
                </el-table-column>
                <!--          已发送-->
                <el-table-column prop="groupId" :label="$t('common.send.state')"
                                 :width="flexWidth('groupId', tableData, $t('common.isreading'))+(lang!=='zh-CN'?40:15)"
                                 v-if="type===3">
                  <template #default="{row}">
                    <template v-if="row.groupId==='3'">
                      <el-button class="btn_reset" link type="success" style="font-size: 12px !important;">
                        {{ $t('common.email.list.sendSuccess') }}
                      </el-button>
                    </template>
                  </template>
                </el-table-column>
                <!--          草稿箱-->
                <el-table-column prop="groupId" :label="$t('common.send.state')" v-else-if="type===2"
                                 :width="flexWidth('groupId', tableData, $t('common.isreading'))+(lang!=='zh-CN'?40:30)">
                  <template #default="{row}">
                    <div v-if="row.groupId==='-1'"
                         style="display: flex;align-items: center;position: relative;justify-content: center">
                      <el-button class="btn_reset" link type="danger" style="font-size: 12px !important;"
                      >
                        {{ $t('common.email.list.sendFailed') }}
                      </el-button>
                      <el-popover
                          class="box-item"
                          :content="showLogError"
                          :effect="'dark'"
                          :show-after="1200"
                          placement="right"
                          @show="handleShowPopover(row)"
                      >
                        <template #reference>
                          <el-icon style="color: red;font-size: 16px;position: absolute;right:-5px;">
                            <Warning/>
                          </el-icon>
                        </template>
                      </el-popover>
                    </div>
                    <template v-else-if="row.groupId==='2'">
                      <template v-if="row.sendTime !== null">
                        <el-button class="btn_reset" v-if="new Date(row.sendTime).getTime() > new Date().getTime()" link
                                   type="warning" style="font-size: 12px !important;">{{ $t('common.wait.sent') }}
                        </el-button>
                        <template v-else>
                          <el-button class="btn_reset" link type="info" style="font-size: 12px !important;">
                            {{ $t('common.email.list.draft') }}
                          </el-button>
                        </template>
                      </template>
                      <template v-else>
                        <el-button class="btn_reset" link type="info" style="font-size: 12px !important;">
                          {{ $t('common.email.list.draft') }}
                        </el-button>
                      </template>
                    </template>
                    <template v-else-if="row.groupId==='5'">
                      <el-button class="btn_reset" link
                                 type="warning" style="font-size: 12px !important;">
                        {{ $t('common.wait.sent') }}
                      </el-button>
                    </template>
                    <template v-else-if="row.groupId==='9'">
                      <el-button class="btn_reset" link
                                 type="primary" style="font-size: 12px !important;">
                        {{ $t('common.examine.wait') }}
                      </el-button>
                    </template>
                    <template v-else-if="row.groupId==='10'">
                      <el-button class="btn_reset" link
                                 type="info" style="font-size: 12px !important;">
                        {{ $t('common.email.list.draft.auto') }}
                      </el-button>
                    </template>
                    <template v-else>
                      {{ $t('common.unknown') }}
                    </template>
                  </template>
                </el-table-column>
                <el-table-column prop="settings" fixed="right" :label="$t('common.cz')" :width="computedTargetWidth">
                  <template #default="scope">
                    <template v-if="type !== 4">
                      <el-button link v-if="type===3||type===2" type="primary" size="small"
                                 @click.stop="handleResend(scope.row)"
                      >{{ $t('common.resend') }}
                      </el-button
                      >
                      <el-button link v-if="type===1" type="primary" size="small"
                                 @click.stop="handleReply(scope.row)"
                      >{{ $t('common.reply') }}
                      </el-button
                      >
                      <el-button link v-if="type===1||type===3" type="primary" size="small"
                                 @click.stop="() => handleReplyDetail('forward',scope.row)"
                      >{{ $t('common.email.forward') }}
                      </el-button
                      >
                      <el-button link type="primary" size="small" @click.stop="handleEdit(scope.row)"
                                 v-if="scope.row.flag===1 && type===1 ||  scope.row.flag===1 && type===3">
                        {{ $t('common.archives.return') }}
                      </el-button>
                    </template>
                    <template v-else>
                      <el-button link type="primary" size="small" @click.stop="requestDelMail(0,scope.row)"
                      >{{ $t('common.restore') }}
                      </el-button
                      >
                      <el-button link type="danger" size="small" @click.stop="requestDelMail(2,scope.row)"
                      >
                        {{ $t('common.delete') }}
                      </el-button>
                    </template>
                  </template>
                </el-table-column>
                <template #empty>
                  <el-empty :description="$t('common.data.empty')" :image="emptyUrl"/>
                </template>
              </ElTable>
            </div>
            <div title="移动到边界进行位置调整" class="mover">
              <div class="mail_info" ref="moveTarget">
                <div class="up_row move"></div>
                <div style="width: 100%;height: 26px;display: flex">
                  <div class="from over_text">
                    {{ $t('common.email.from') }}：{{ currentMail.mailBody?.from }}
                  </div>
                  <div class="to over_text" ref="toRef">
                    <el-popover
                        v-if="formatText(currentMail.mailRecipientVOList, 'to')"
                        :visible="visibleTo"
                        width="500"
                        :content="formatText(currentMail.mailRecipientVOList, 'to')"
                        :effect="'dark'"
                        popper-class="visible"
                    >
                      <template #reference>
                    <span @mouseenter="showPopover(formatText(currentMail.mailRecipientVOList, 'to'),'to')"
                          @mouseleave="delayedHidePopover('to')">{{
                        $t('common.email.to')
                      }}：{{ formatText(currentMail.mailRecipientVOList, 'to') }}</span>
                      </template>
                      <div @mouseenter="keepPopoverVisible('to')" @mouseleave="hidePopover('to')">
                        {{ formatText(currentMail.mailRecipientVOList, 'to') }}
                      </div>
                    </el-popover>
                    <template v-else>
                      {{ $t('common.email.to') }}：{{ formatText(currentMail.mailRecipientVOList, 'to') }}
                    </template>
                  </div>
                  <div class="cc over_text">
                    <el-popover
                        v-if="formatText(currentMail.mailRecipientVOList, 'cc')"
                        :visible="visibleCC"
                        width="500"
                        :content="formatText(currentMail.mailRecipientVOList, 'cc')"
                        :effect="'dark'"
                        popper-class="visible"
                    >
                      <template #reference>
                <span
                    @mouseenter="showPopover(formatText(currentMail.mailRecipientVOList, 'cc'),'cc')"
                    @mouseleave="delayedHidePopover('cc')"
                >
                {{ $t('common.cc') }}：{{ formatText(currentMail.mailRecipientVOList, 'cc') }}
                </span>
                      </template>
                      <div @mouseenter="keepPopoverVisible('cc')" @mouseleave="hidePopover('cc')">
                        {{ formatText(currentMail.mailRecipientVOList, 'cc') }}
                      </div>
                    </el-popover>
                    <template v-else>
                      {{ $t('common.cc') }}：{{ formatText(currentMail.mailRecipientVOList, 'cc') }}
                    </template>
                  </div>
                </div>
                <div class="down_row move"></div>
              </div>
            </div>
            <div class="downBox" :style="{height:`calc(100% - ${inboxTop + 10}px)`}">
              <!--右下div内容-->
              <!--              <iframe ref="pageframe" id="pageframe"-->
              <!--                      :srcdoc="iframeContent"-->
              <!--                      frameborder="0"-->
              <!--                      :style="{width: '100%',height: '100%'}"-->
              <!--                      :class="detailLoading?'scroll':'scroll loaded'"-->
              <!--              >-->
              <!--                <p>Your browser does not support preview features, please download Google browser or other modern-->
              <!--                  browsers.</p>-->
              <!--              </iframe>-->
              <div v-loading="detailLoading" style="width: 100%;height: 100%">
                <iframe ref="pageframe" id="pageframe" :srcdoc="iframeContent"
                        frameborder="0"
                        :style="{width: '100%',height: '100%'}"
                        :class="detailLoading?'scroll':'scroll loaded'"
                >
                  <p>Your browser does not support preview features, please download Google browser or other modern
                    browsers.</p>
                </iframe>
                <div v-if="isDragging" id="mask"
                     :style="{width: '100%',height:`calc(100% - ${inboxTop + 10}px)`,background:'rgba(0,0,0,0)',position:'absolute',zIndex:999,top:inboxTop+'px'}">
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>


      <!--      高级搜索-->
      <el-drawer
          v-model="drawer"
          :title="$t('common.search.advanced')"
          :direction="direction"
          class="el_modal"
          style="padding: 12px"
      >
        <el-form
            :label-position="labelPosition"
            label-width="100px"
            :model="formLabelAlign"
        >
          <el-form-item :label="$t('common.customer.nameList')+':'" prop="customerName">
            <el-input size="small" v-model="formLabelAlign.customerName" :placeholder="$t('common.please.input')"/>
          </el-form-item>
          <el-form-item :label="$t('common.customer.levelList')+':'" prop="customerTypeId">
            <el-select
            size="small"
                v-model="formLabelAlign.customerTypeId"
                style="width: 100%;"
                popper-class="customer-level"
                :placeholder="$t('common.please.select')"
            >
              <el-option
                  v-for="item in tableDataLevel"
                  :key="item.id"
                  :label="item.customerType"
                  :value="item.id"
              >
                <div class="inner_select">
                  {{ item.customerType }}
                </div>
              </el-option>
            </el-select>
          </el-form-item>
          <el-form-item :label="$t('common.customer.Region')+':'" prop="zoneAddress">
            <el-select
            size="small"
                filterable
                v-model="formLabelAlign.zoneAddress"
                style="width: 100%;"
                :placeholder="$t('common.please.select')"
            >
              <el-option
                  v-for="item in areaList"
                  :key="item.country"
                  :label="lang!=='zh-CN'?item.countryEn:item.country"
                  :value="lang!=='zh-CN'?item.countryEn:item.country"
              />
            </el-select>
          </el-form-item>
          <!--          发件箱-->
          <!--          <el-form-item :label="$t('reply.status')+':'" prop="isAnswer" v-if="type===3">-->
          <!--            <el-select-->
          <!--                filterable-->
          <!--                v-model="formLabelAlign.isAnswer"-->
          <!--                style="width: 100%;"-->
          <!--                :placeholder="$t('common.please.select')"-->
          <!--            >-->
          <!--              <el-option :label="$t('common.all')" :value="-1"></el-option>-->
          <!--              <el-option :label="$t('common.email.status1')" :value="1"></el-option>-->
          <!--              <el-option :label="$t('common.email.status2')" :value="0"></el-option>-->
          <!--            </el-select>-->
          <!--          </el-form-item>-->
          <!--          收件箱-->
          <!--          <el-form-item :label="$t('reply.status')+':'" prop="isReply" v-if="type===1">-->
          <!--            <el-select-->
          <!--                filterable-->
          <!--                v-model="formLabelAlign.isReply"-->
          <!--                style="width: 100%;"-->
          <!--                :placeholder="$t('common.please.select')"-->
          <!--            >-->
          <!--              <el-option :label="$t('common.all')" :value="-1"></el-option>-->
          <!--              <el-option :label="$t('common.email.status1')" :value="1"></el-option>-->
          <!--              <el-option :label="$t('common.email.status2')" :value="0"></el-option>-->
          <!--            </el-select>-->
          <!--          </el-form-item>-->
          <el-form-item :label="$t('read.status')+':'" prop="isTrack" v-if="type===3">
            <el-select
            size="small"
                filterable
                v-model="formLabelAlign.isTrack"
                style="width: 100%;"
                :placeholder="$t('common.please.select')"
            >
              <el-option :label="$t('common.all')" :value="-1"></el-option>
              <el-option :label="$t('read.status.isread')" :value="1"></el-option>
              <el-option :label="$t('read.status.unread')" :value="0"></el-option>
            </el-select>
          </el-form-item>
          <!--          <el-form-item :label="$t('common.send.state')" v-if="type===2">-->
          <!--            <el-select-->
          <!--                filterable-->
          <!--                v-model="formLabelAlign.type"-->
          <!--                style="width: 100%;"-->
          <!--                :placeholder="$t('common.please.select')"-->
          <!--            >-->
          <!--              <el-option :label="$t('common.setting.allTime')" :value="2"></el-option>-->
          <!--              <el-option :label="$t('common.wait.sent')" :value="5"></el-option>-->
          <!--              <el-option :label="$t('common.email.list.sendFailed')" :value="-1"></el-option>-->
          <!--              <el-option :label="$t('common.examine.wait')" :value="9"></el-option>-->
          <!--              <el-option :label="$t('common.option.select.base.draft')" :value="10"></el-option>-->
          <!--              <el-option :label="$t('common.option.select.base.auto.draft')" :value="12"></el-option>-->
          <!--            </el-select>-->
          <!--          </el-form-item>-->
          <el-form-item :label="$t('common.date')+':'" prop="rangePickerTime">
            <el-date-picker
            size="small"
                style="width: 100%;"
                v-model="formLabelAlign.rangePickerTime"
                type="daterange"
                format="YYYY-MM-DD HH:mm:ss"
                range-separator="~"
                :start-placeholder="$t('search.start.date')"
                :end-placeholder="$t('search.end.date')"
            />
          </el-form-item>
          <!--          <el-form-item :label="$t('email.list.draft.status')+':'" prop="draftStatus" v-if="type===2">-->
          <!--            <el-select-->
          <!--                filterable-->
          <!--                v-model="formLabelAlign.isReply"-->
          <!--                style="width: 100%;"-->
          <!--                :placeholder="$t('common.please.select')"-->
          <!--            >-->
          <!--              <el-option :label="'草稿'" :value="1"></el-option>-->
          <!--              <el-option :label="'自动草稿'" :value="0"></el-option>-->
          <!--            </el-select>-->
          <!--          </el-form-item>-->
          <!--          邮件主题、内容-->
          <el-form-item :label="$t('sending.table.col.title')+':'" prop="email">
            <el-input size="small" v-model="formLabelAlign.subject" :placeholder="$t('common.please.input')"/>
          </el-form-item>
          <el-form-item :label="$t('common.height.search.content')+':'" prop="content">
            <el-input size="small" v-model="formLabelAlign.content" :placeholder="$t('common.please.input')"/>
          </el-form-item>
          <el-form-item>
            <div class="fx-j-e" style="margin-top: 10px">
              <el-button size="small" type="primary" style="margin-right: 12px;font-size: 13px;" @click="handleSearch('search')">{{
                  $t('common.search')
                }}
              </el-button>
              <el-button size="small" style="margin-left: 10px;font-size: 13px;" @click="filterReset">{{
                  $t('common.empty')
                }}
              </el-button>
            </div>
          </el-form-item>
        </el-form>
      </el-drawer>
      <!--      建档-->
      <ReturnEmails ref="emailsReturn" v-if="dialogVisible" v-model="dialogVisible" @close="close"
                    @createCustomer="createdNewCustomer" :targetEmail="activeItemRow" :reGetList="getMailList"
      ></ReturnEmails>
      <!--      创建客户-->
      <CustomerCreated ref="customerCreated" v-if="dialogVisibleCreatedMessage"
                       v-model="dialogVisibleCreatedMessage" @close="closeCreated" :innerDialog="dialogVisible"
                       @changeInnerDialog="close"></CustomerCreated>
      <BlackConfirmModal :showFlag="blackModalShow" :list="multipleSelection.map(item => item.from)"
                         @succ="handleBlackSucc" @cancel="handleBlackCancel"/>
      <!--      彻底删除-->
      <Dialog
          v-model="dialogVisibleDelete"
          :title="$t('sys.team.info')"
          :dialogVisible="dialogVisibleDelete"
          :isHeadLine="false"
          :width="420"
          @update:dialogVisible="(val) => (dialogVisibleDelete = val)"
          align-center
      >
        <template #content>
          <div class="inners_warning">
            <div><img
                src="data:image/png;base64,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"/>
            </div>
            <div style="font-size: 13px;margin: 20px 0px">
              {{ $t('other.text.ask.email.delete.empty') }}
            </div>
          </div>
        </template>
        <template #footer>
          <div class="setting_center">
            <el-button size="small" style="margin-right: 20px" @click.native.stop="dialogVisibleDelete = false">
              {{
                $t('common.sss16')
              }}
            </el-button>
            <el-button size="small" type="primary" @click="deleteAll" :loading="deleteLoading">{{ $t('common.confirm') }}</el-button>
          </div>
        </template>
      </Dialog>
      <!--组件抽离-->
      <el-popover
          v-if="popoverType!==0"
          virtual-triggering
          :virtual-ref="tempRef"
          v-model:visible="visiblePopover"
          :placement="popoverType===1?'top':'bottom'"
          :width="popoverType===1?204:300"
          :show-after="1200"
          popper-class="sp_model_popover"
          :effect="popoverType!==1?'dark':'light'"
          :popper-options="{
              modifiers: [{
		          name: 'offset',
		          options: {
			          offset: [8, 8]
		          }
	        }]
	    }">
        <template v-if="popoverType===2">
          <el-tooltip placement="top" style="pointer-events: none">
            <div slot="content" style="pointer-events: none">
              {{
                $t("common.email.list.isTrack", {
                  openTime: emailListCheckoutTarget.openTime,
                  openAddress: emailListCheckoutTarget.openAddress,
                  openIp: emailListCheckoutTarget.openIp,
                  openCount: emailListCheckoutTarget.openCount,
                })
              }}
            </div>
          </el-tooltip>
        </template>
        <template v-else-if="popoverType===3">
          {{ emailListCheckoutTarget.subject }}
        </template>
      </el-popover>
      <!--   添加备注   -->
      <Remark v-if="visitableRemark" v-model="visitableRemark" @close="closeRemark" :isHeadLine="false"
              :currentItem="currentItem" @getList="getMailList"></Remark>
    </div>
  </div>
</template>
<script>
import {onMounted, reactive, ref, watch, provide, computed, nextTick, onBeforeUnmount} from 'vue';
import {
  getMail,
  tagMail,
  tagAllRead,
  delMail,
  getMailByUserId,
  getMailDetails, getGroupMailList, groupEmail
} from '@/api';
import {
  getEmailLog,
  requestMailAccessory,
  requestUpdateMailRemark,
} from '@/api/mail';
import {getTeamUserListAll} from '@/api/groups';
import {ElMessage, ElTable} from 'element-plus';
import {useStore} from 'vuex';
import {useRoute, useRouter} from "vue-router";
import Dialog from "@/components/Dialog.vue";
import MyTitles from "@/views/Customer/Detail/MyTitles.vue";
import Forms from "@/views/Customer/CreateCheck/Forms.vue";
import Cards from "@/views/Customer/Cards.vue";
import ContactTable from "@/views/Customer/Detail/ContactTable.vue";
import BlackConfirmModal from '../BlackConfirmModal.vue';
import {debouncePlus, throttle} from "@/utils/mylodash"
import {i18n} from "@/lang";
import {Plus} from '@element-plus/icons-vue'
import {emptyUrl, htmlReg, POPOVER_DELAY_TIME, TIME_OUT} from '@/utils/statusParams'
import ReturnEmails from "@/components/DiaPops/Returns/ReturnEmails.vue";
import CustomerCreated from "@/components/DiaPops/Returns/CustomerCreated.vue";
import {formatSize} from "@/utils/file";
import {flexWidth} from "@/utils/tableWidth";
import {addImgOnErrorAttribute, containsHtmlTags, convertLinksToHTML, convertToHTML} from "@/utils/iframe";
import router from "@/router";
import {getScaleValue} from "@/utils/view"
import {getPosType} from "@/utils/device";
import Remark from "@/components/Remark/index.vue"
import CreateDir from "@/views/Cloud/Components/CreateDir.vue";
import {highlightKeyword} from '@/utils/util.js'
import OverflowTooltip from "@/components/OverflowTooltip/index.vue"
import {replaceEmptyPTagsWithBr, resetCss} from "@/utils/TinyMCE";
import sessionStore from "@/utils/sessionStore";
import {Storage} from "@/utils/storage";

function numStr(num) {
  return num < 10 ? `0${num}` : num;
}

function formatTime(date) {
  return `${date.getFullYear()}-${numStr(date.getMonth() + 1)}-${numStr(date.getDate())}`;
}

const commandList = [1, 0, 1, 0];

const initForm = {
  customerName: null,
  customerTypeId: null,
  zoneAddress: null,
  isAnswer: null,
  isTrack: null,
  isReply: null,
  type: 2,
  rangePickerTime: [],
  email: '',
  content: ''
}
export default {
  methods: {
    highlightKeyword,
    getPosType,
    router() {
      return router
    }, flexWidth, formatSize
  },
  computed: {
    Plus() {
      return Plus
    }
  },
  components: {
    Remark,
    OverflowTooltip,
    CreateDir,
    ElTable,
    CustomerCreated,
    ReturnEmails,
    ContactTable,
    Cards,
    Forms,
    MyTitles,
    Dialog,
    BlackConfirmModal,
  },
  // (-1:失败邮件,1:收件箱,2:草稿箱,3:已发送,4:垃圾箱,4:垃圾邮件)
  props: ['type', 'group'],
  setup(props) {
    const isShiftPressed = ref(false); // 标记 Shift 键是否被按下
    const router = useRouter();
    const route = useRoute();
    const store = useStore();
    const configId = ref('all');
    const emailList = ref([]);
    const searchCount = ref('');
    const current = ref(1);
    const size = ref(40);
    const total = ref(0);
    const tableData = ref([]);
    const loading = ref(false);
    const multipleTableRef = ref(null);
    const multipleSelection = ref([]);
    const currentMail = ref({});
    const inboxRef = ref(null);
    const tableHeight = ref(200);
    const drawer = ref(false);
    const direction = ref('rtl')
    const labelPosition = ref('top');
    const selectedTeamId = ref('');
    const selectedFolder = ref('all');
    const iframeContent = ref('');
    const selectedUserIdMap = ref({});
    const formLabelAlign = reactive({...initForm});
    const tableDataSelect = ref([]);
    const tableRef = ref(null);
    const blackModalShow = ref(false);
    const dialogVisibleDelete = ref(false);

    // 设备标识
    const deviceFlag = computed(() => {
      return getPosType()
    })

    // 下标记录
    // const lastIdx = ref(-1);
    // // shift标识
    // const shiftFlag = ref(false);

    // 文件夹信息
    const fileList = computed(() => route.path !== '/email/inbox' ? [{
      "id": "99999",
      "fileName": i18n.global.t('common.emailbox.receive'),
    }, ...store.state.sidebar.fileList.filter(item => item.id !== selectedFolder.value)] : store.state.sidebar.fileList.filter(item => item.id !== selectedFolder.value))

    const targetFileList = computed(() => route.path !== '/email/inbox' && route.path !== '/email/has_send' && route.path !== '/email/draft' && route.path !== '/email/waste' && route.path !== '/email/foldergroup' ? [{
      "id": "99999",
      "fileName": i18n.global.t('common.emailbox.receive'),
    }, {
      "id": "99999",
      "fileName": i18n.global.t('common.has.sent'),
    }, ...store.state.sidebar.targetFileList.filter(item => item.id !== selectedFolder.value)] : store.state.sidebar.targetFileList.filter(item => item.id !== selectedFolder.value))

    // 建档信息
    const ruleForm = computed(() => store.state.customer.ruleForm);
    const form = computed(() => store.state.customer.form);
    // 区域列表
    const areaList = computed(() => store.state.customer.areaList);
    // 客户等级
    const tableDataLevel = computed(() => store.state.cusList.tableData);
    // 对话框
    const dialogVisible = ref(false);
    // 对话框表单信息
    const forms = reactive({email: '', customerName: '', merge: true, contactName: ''})
    const teamId = computed(() => store.state.email.teamID);
    const options = []
    const optionsCustomers = ref([])
    //默认文件id
    const fileGroupId = computed(() => store.state.sidebar.targetFileList.length > 0 ? store.state.sidebar.targetFileList[0].id : null)


    // 语言
    const lang = computed(() => store.state.system.langLocal)
    // 对话框中的建档
    const dialogVisibleCreatedMessage = ref(false);
    // 联系人
    const contactPerson = [{
      label: i18n.global.t('common.email.existingContacts'),
      value: true
    }, {label: i18n.global.t('common.email.newContacts'), value: false}];
    // 手动筛选联系人列表
    const contactList = ref([])


    const handleSelectUser = async (val) => {
      if (route.path === '/email/foldergroup') {
        console.log(val, 'val', selectedTeamId.value);
        await store.commit("sidebar/setTargetFileList", [])
        await store.dispatch("sidebar/getEmailGroupFileListApis", {teamId: teamId.value, userId: selectedTeamId.value})
        selectedFolder.value = 'all';
        console.log(selectedFolder.value, targetFileList.value, 'selectedFolder')
        await getMailList()
      }
    }
    const handleSelectFolder = async (val) => {
      console.log(val, 'val')
      selectedFolder.value = val;
      await getMailList();
    }


    // 边界控制归档选择
    // const customerFlag = ref(false)
    const visiblePop = ref(false)

    const moneySendGrandson = function (value) {
      setTimeout(() => {
        getMailList()
      }, 3000)
    }
    provide('moneySendGrandson', moneySendGrandson)

    const removeEmail = (index) => {
      ruleFormUsers.mailContactEmailList.splice(index, 1);
    };
    // 编辑邮件信息
    const activeItemRow = ref([])
    const emailsReturn = ref(null)

    async function handleEdit(row) {
      dialogVisible.value = true
      // console.log(route.path, 'route', row)
      if (route.path === "/email/has_send") {
        activeItemRow.value = toEmailObj(row.mailRecipientList)
      } else {
        activeItemRow.value = [{email: row.from}]
      }

      await nextTick();
      await emailsReturn.value.getAllCustomers();
    }

    //邮箱转换
    const toEmailObj = (arr) => {
      return arr.map(item => {
        return {email: item}
      })
    }

    const createdNewCustomer = async (value) => {
      dialogVisibleCreatedMessage.value = true
      store.commit('customer/setRuleForm', {
        zoneCode: "",
        customerCode: "",
        zoneAddress: "",
        customerName: "",
        setUpTime: "",
        economicNature: "",
        companyWebsite: "",
        companyAddress: "",
        phoneWayList: [],
        emailWayList: [],
        companyFax: "",
        companyRemark: "",
        customerLevel: "",
        customerType: "",
        customerTypeId: "",
        product: "",
        marketingRemark: " ",
        createBy: "",
        branchAdmin: "",
        mangerVOList: [{managerName: ''}]
      });
      await store.commit('customer/setForm', {
        phones: [{phoneNumber: "", isDefault: true}],
        emails: [{email: value, isDefault: true}],
      })
    }

    function getMailListConf() {
      getMailByUserId({teamId: teamId.value, userId: selectedTeamId.value || ''})
          .then((res) => {
            // // console.log(res.result, '邮箱配置列表');
            const list = res.result || [];
            emailList.value = list.map(item => ({label: item.username, value: item.id}));
            configId.value = 'all'
          });
    }

    const teamList = computed(() => store.state.email.teamList)

    const userInfo = computed(() => store.state.user.userInfo)

    const ACCOUNTS_STORAGE_KEY = 'accounts'
    const activeUserId = computed(() => {
      const fromUserInfo = userInfo.value?.id ?? userInfo.value?.userID ?? userInfo.value?.guid ?? userInfo.value?.account
      const fromAccounts = Storage.get(ACCOUNTS_STORAGE_KEY)?.currentId
      const id = fromUserInfo ?? fromAccounts
      return id === undefined || id === null ? '' : String(id)
    })


    async function getAllUserList() {
      const result = await getTeamUserListAll({teamId: teamId.value});
      if (result.code !== 200) {
        ElMessage.error(result.message)
        return
      }
      console.log(result.result, 'result.result')
      console.log(teamList.value, 'teamList.value')

      if (result.result && result.result.length === 0) {
        if (teamList.value.length >= 1) {
          const nextTeamId = String(teamList.value[0].id)
          store.commit('email/setCurTeamID', nextTeamId)
        } else {
          store.commit('email/setCurTeamID', '')
          //   如果查询到没有团队的详情的话那么就跳转到首页
          router.push("/dashboard")
        }
      }
      console.log(result.result, 'result.result')
      if (!route.params.folderId) {
        tableDataSelect.value = result.result || [];
      } else {
        tableDataSelect.value = result.result.filter(item => String(item.userId) === activeUserId.value)
      }
      if (tableDataSelect.value.length) {
        console.log(tableDataSelect.value, tableDataSelect.value.find(_ => String(_.userId) === activeUserId.value), 'tableDataSelect.value')
        selectedTeamId.value = tableDataSelect.value.find(_ => String(_.userId) === activeUserId.value)?.userId;
        selectedUserIdMap.value = tableDataSelect.value.reduce((prev, item) => {
          prev[item.id] = item.userId;
          return prev;
        }, {});
        console.log('selectedUserIdMap.value', selectedUserIdMap.value)
        console.log(emailList.value, 'emailList.value')
        // configId.value = emailList.value && emailList.value.length > 0 && emailList.value[0].value || "all"
      }
    }

    async function handleDownload(scope) {
      const result = await requestMailAccessory({id: scope.row.id});
      if (result.code !== 200) {
        ElMessage.error(result.message);
        return;
      }
      console.log(result, 'result')
      window.open(`${location.origin}/email/detail/${scope.row.id}/${JSON.stringify({
        flag: scope.row.flag ? scope.row.flag : 0,
        isExtend: scope.row.isExtend ? scope.row.isExtend : 0,
        from: scope.row.from
      })}/${props.type}`);
    }

    function handleToCustomer(scope) {
      router.push({
        path: `/email/customer/detail/${scope.row.id}`,
        query: {type: 1},
      });
    }

    function formatText(list, type) {
      if (!list || !list.length) {
        return '';
      }
      const infoMap = list.reduce((prev, item) => {
        if (!prev[item.mailType]) {
          prev[item.mailType] = [];
        }
        prev[item.mailType].push(item.mail);
        return prev;
      }, {});
      return infoMap[type] ? infoMap[type].join(' , ') : '';
    }

    async function handleCurrentChange(page) {
      current.value = page;
      tableRef.value.setScrollTop(0);
      await getMailList(sortObj.value);
    }

    //回复
    function handleReply(row) {
      sessionStore.set('reSend', row);

      const query = {
        id: row.id,
        flag: row.flag,
        isRead: row.isRead,
        mailType: props.type,
      };

      if (row.flag === 0 && row.customerId) {
        query.customerId = row.customerId;
      }

      // 构造 query 参数字符串
      const queryString = new URLSearchParams(query).toString();

      // 拼接完整 URL（假设是 hash 模式或 history 模式可视项目结构调整）
      const url = `${location.origin}/email/write_mail?${queryString}`;

      // 在新标签页打开
      window.open(url, '_blank');
    }

    //重发
    function handleResend(row) {
      sessionStore.set('reSend', row);

      const query = {
        id: row.id,
        flag: row.flag,
        type: "resend",
        mailType: props.type,
      };

      if (row.flag === 0 && row.customerId) {
        query.customerId = row.customerId;
      }

      // 构造 query 参数字符串
      const queryString = new URLSearchParams(query).toString();

      // 构造 URL 并在新标签页中打开（假设使用 history 模式）
      const url = `${location.origin}/email/write_mail?${queryString}`;
      window.open(url, '_blank');
    }

    async function getMailList(sort) {
      let folderId = route.params.folderId || route.path === '/email/foldergroup';
      const teamIdCheck = route.query.teamID ? route.query.teamID : sessionStore.get("teamId");
      loading.value = true;
      const formParams = {...formLabelAlign};
      console.log(formParams, teamIdCheck, 'formParams')
      delete formParams.rangePickerTime;
      delete formParams.isTrack;
      delete formParams.isAnswer;
      delete formParams.isReply;
      let payload = {
        ...formParams,
        mailConfigId: configId.value === 'all' ? null : configId.value,
        pageNo: isSearch.value ? 1 : current.value,
        type: (props.type === 2 ? formParams.type : props.type) || 1, // `group_id` char(50) DEFAULT NULL COMMENT '邮件类型(-1:失败邮件,1:收件箱,2:草稿箱,3:已发送,4:已删除,5:垃圾邮件)',
        userId: selectedTeamId.value,
        teamId: teamIdCheck,
        search: isClear.value ? "" : searchCount.value,
        pageSize: size.value,
        stress: null,
        isAnswer: formLabelAlign.isAnswer === -1 ? "" : formLabelAlign.isAnswer,
        isTrack: formLabelAlign.isTrack === -1 ? "" : formLabelAlign.isTrack,
        isReply: formLabelAlign.isReply === -1 ? "" : formLabelAlign.isReply,
        startTime: formLabelAlign.rangePickerTime.length ? formatTime(formLabelAlign.rangePickerTime[0]) : null,
        endTime: formLabelAlign.rangePickerTime.length ? formatTime(formLabelAlign.rangePickerTime[1]) : null,
        // rangePickerTime: null,
        // orderTime: 2,
      }
      if (folderId) {
        payload = {...payload, fileGroupId: folderId}
      }
      if (route.path === '/email/foldergroup') {
        if (selectedFolder.value === "all") {
          delete payload.fileGroupId;
        } else {
          payload = {...payload, fileGroupId: selectedFolder.value}
        }
      }
      if (sort) {
        console.log(sort, 'sort')
        payload = {...payload, ...sort}
      }

      let ApiTarget = folderId ? getGroupMailList : getMail;

      if (folderId) {
        delete payload.type
      }

      const result = await ApiTarget(payload);
      if (result.code !== 200) {
        ElMessage.error(result.message)
        return
      }
      loading.value = false;
      isSearch.value = false;
      // // console.log('列表', result);
      const {records, total: newTotal} = result.result;
      total.value = newTotal;
      tableData.value = [...records]
      current.value = result.result.current;
      console.log('接口 records === tableData.value ?', records, records === tableData.value, tableData.value)
    }

    let endIndex = -1;
    //按住shirt键
    const handleKeyDown = (event) => {
      console.log(event.key, 'event.key')
      if (event.key === 'Shift' && event.keyCode === 16) {
        // console.log("进来了-----------------", event.key, event.keyCode);
        isShiftPressed.value = true;
      }
    };

    const handleKeyUp = (event) => {
      if (event.key === 'Shift' && event.keyCode === 16) {
        isShiftPressed.value = false;
      }
    };

    function handleSelectionChange(val) {
      // console.log("val-----------------------", val)
      //判断是否按住shirt键盘
      console.log(isShiftPressed.value);
      endIndex = val.length > 1 ? tableData.value.findIndex(item => item.id === val[val.length - 1].id) : -1;
      const startIndex = val.length > 1 ? tableData.value.findIndex(item => item.id === val[val.length - 2].id) : -1;
      console.log(endIndex, startIndex);
      if (isShiftPressed.value && val.length > 1 && endIndex !== startIndex) {
        const start = startIndex < endIndex ? startIndex : endIndex;
        const end = endIndex < startIndex ? startIndex : endIndex;
        // console.log(start, end, '===============');
        for (let i = start; i <= end; i++) {
          const row = tableData.value[i];
          if (start === i || i === end) {
            continue;
          }
          console.log(row, '更新');
          if (row) {
            tableRef.value.toggleRowSelection(row, true); // 调用表格组件的方法来更新选中状态
          }
        }
        nextTick(() => {
          multipleSelection.value = tableRef.value.getSelectionRows();
          console.log(tableRef.value.getSelectionRows(), '当前选中行');
        });
      } else {
        //走正常逻辑
        multipleSelection.value = val;
      }
    }

    async function requestTagMail(tag, type) {
      const result = await tagMail({
        [type]: tag,
        mailIdList: multipleSelection.value.map(item => item.id),
      });
      if (result.code !== 200) {
        ElMessage.error(result.message);
        return;
      }
      // 更新标志
      await store.dispatch('countshow/getTeamAllDataApis')

      if (multipleSelection.value.length === 1) {
        let isStress = multipleSelection.value[0][type]
        console.log(isStress, 'isStress')
        //   软删除
        tableData.value = tableData.value.map(item => {
          if (item.id === multipleSelection.value[0].id) {
            return {...item, [type]: isStress === 1 ? 0 : 1}
          } else {
            return item
          }
        })
      } else {
        // 删除刷新
        await getMailList()
      }
    }

    async function requestTagAllRead() {
      // 文件夹 已读
      const payload = {
        teamId: teamId.value,
        userId: selectedTeamId.value,
        type: props.type || 1,
        mailConfigId: configId.value === 'all' ? null : configId.value,
      }
      if (route.params.folderId) {
        payload.fileGroupId = route.params.folderId
      }
      const result = await tagAllRead(payload);
      if (result.code !== 200) {
        ElMessage.error(result.message);
        return;
      }
      ElMessage.success(i18n.global.t('email.list.all.isread'));
      // 更新标志
      await store.dispatch('countshow/getTeamAllDataApis')
      await getMailList();
    }

    async function requestDelMail(flag, isSelect) {
      // // console.log(flag, isSelect, 'ff')
      if (isSelect) {
        multipleSelection.value.push(isSelect)
      }

      if (!multipleSelection.value.length) {
        ElMessage.error(i18n.global.t('sys.tip.unselect.email'));
        return;
      }

      // 构建请求参数
      const params = {
        type: flag, // 0 还原  1 已删除 2彻底删除
        mailIdList: multipleSelection.value.map(item => item.id),
      };

      // 只有 type: 1 时才需要传递 originalPosition
      if (flag === 1) {
        params.originalPosition = props.type;
      }

      if (flag === 0) {
        const result = await delMail(params);
        if (result.code !== 200) {
          ElMessage.error(result.message);
          return;
        }
        ElMessage.success(i18n.global.t('email.list.reduction'));
        setTimeout(async () => {
          await getMailList();
        }, 1500);
      }
      if (flag === 1) {
        const result = await delMail(params);
        if (result.code !== 200) {
          ElMessage.error(result.message);
          return;
        }
        ElMessage.success(i18n.global.t('sys.message.success.delete'));
        setTimeout(async () => {
          await getMailList();
        }, 1500);
      }
      if (flag === 2) {
        dialogVisibleDelete.value = true;
      }
    }

    // 彻底删除提示
    const deleteLoading = ref(false)

    async function deleteAll() {
      deleteLoading.value = true
      // type: 2 不需要 originalPosition
      const result = await delMail({
        type: 2, // 0 还原  1 已删除 2彻底删除
        mailIdList: multipleSelection.value.map(item => item.id),
      });
      if (result.code !== 200) {
        deleteLoading.value = false
        ElMessage.error(result.message);
        return;
      }
      deleteLoading.value = false
      ElMessage.success(i18n.global.t('email.list.delete'));
      dialogVisibleDelete.value = false
      setTimeout(async () => {
        await getMailList();
      }, 1500);
    }


    async function handleBlack() {
      if (!multipleSelection.value.length) {
        ElMessage.error(i18n.global.t('sys.tip.unselect.email'));
        return;
      }
      blackModalShow.value = true;
    }

    const detailLoading = ref(false)

    const handleCurrentRowChange = async (current) => {
      if (current) {
        getTargetMailId.value = current.id;
      }
      if (current !== null) {
        detailLoading.value = true
        try {
          const result = await getMailDetails({id: current.id});
          let content = result.result?.mailBody?.content;
          const insertionContent = `<script>
            function errorImage(img) {
                console.log(img,'img')
                img.onerror = null;
                img.src="data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAEAAAABCAIAAACQd1PeAAAADElEQVR42mP4//8/AAX+Av4zEpUUAAAAAElFTkSuQmCC"
            }
        <\/script>`;
          if (!content) {
            iframeContent.value = replaceEmptyPTagsWithBr(resetCss + '')
          } else {
            if (containsHtmlTags(content)) {
              const replacedHtmlString = addImgOnErrorAttribute(content)
              console.log('content', content);
              const res = replacedHtmlString.replace(/(<html[^>]*>)/, '$1' + insertionContent);
              iframeContent.value = replaceEmptyPTagsWithBr(resetCss + res);
            } else {
              console.log("非html")
              // 纯图片需要直接展示
              if (content.indexOf('https://s3gw.cmbimg.com') !== -1) {
                iframeContent.value = replaceEmptyPTagsWithBr(resetCss + content);
              } else {
                iframeContent.value = replaceEmptyPTagsWithBr(resetCss + convertLinksToHTML(convertToHTML(content)));
              }
            }
          }
          console.log(iframeContent.value, 'iframeContent')
          currentMail.value = result.result;
          detailLoading.value = false
        } catch (e) {
          console.log('------------iframe----------')
          detailLoading.value = false
        }
      }
    }

    const getTargetMailId = ref(null)

    async function handleViewDetail(row) {
      console.log('双击', row);
      // if (props.type === 3) {
      //   const query = {id: row.id, flag: row.flag, type: "resend"};
      //   if (row.flag === 0 && row.customerId) {
      //     query.customerId = row.customerId;
      //   }
      //   router.push({
      //     path: '/email/write_mail',
      //     query,
      //   });
      // } else if (props.type === 2) {
      //   const query = {id: row.id, flag: row.flag, type: "editMail", fromType: props.type};
      //   if (row.flag === 0 && row.customerId) {
      //     query.customerId = row.customerId;
      //   }
      //   router.push({
      //     path: '/email/write_mail',
      //     query,
      //   });
      // } else {
      getTargetMailId.value = row.id
      //邮件已读
      multipleSelection.value = [row]
      // 已读的邮件 避免被重复赋值
      if (row?.isRead !== 1) {
        await requestTagMail(commandList[0], 'isRead');
      }
      window.open(`${location.origin}/email/detail/${row.id}/${JSON.stringify({
        flag: row.flag ? row.flag : 0,
        isExtend: row.isExtend ? row.isExtend : 0,
        from: row.from,
        customerId: row.customerId,
      })}/${props.type}`);

      // window.location.href = `${location.origin}/email/detail/${row.id}/${JSON.stringify({
      //     flag: row.flag ? row.flag : 0,
      //     isExtend: row.isExtend ? row.isExtend : 0,
      //     from: row.from,
      //   })}/${props.type}`;
      await getMailList();
      // }
    }

    async function handleCommand(val) {
      // // console.log(val, multipleSelection.value);
      if (!multipleSelection.value.length) {
        ElMessage.error(i18n.global.t('sys.tip.unselect.email'));
        return;
      }
      const type = val === 0 || val === 1 ? 'isRead' : 'isStress';
      requestTagMail(commandList[val], type);
    }

    // 邮件分组
    async function handleGroupEmail(id) {
      if (!multipleSelection.value.length) {
        ElMessage.error(i18n.global.t('sys.tip.unselect.email'));
        return;
      }
      console.log(multipleSelection.value, 'multipleSelection.value')
      if (id === '99999') {
        // alert("移动到 收件箱")
        const result = await delMail({
          type: 3, // 0 还原  1 已删除 2彻底删除 3.还原
          mailIdList: multipleSelection.value.map(item => item.id),
          teamId: teamId.value,
        });
        if (result.code !== 200) {
          ElMessage.error(result.message);
          return;
        }
        ElMessage.success(result.message)
        await getMailList()
      } else {
        await groupEmailTarget(id)
      }
    }

    // 邮件分组
    async function groupEmailTarget(id) {
      try {
        const payload = {
          userId: selectedTeamId.value,
          fileGroupId: id,
          mailIdList: multipleSelection.value.map(item => item.id),
          originalPosition: props.type * 1,
        }
        console.log(payload)
        const res = await groupEmail(payload)
        ElMessage.success(res.message)
        await store.dispatch('countshow/getTeamAllDataApis')
        await getMailList()
      } catch (e) {

      }
    }

    async function handleSettingStress(scope, type) {
      // // console.log(scope.row, type);
      multipleSelection.value = [scope.row];
      handleCommand(type);
      // 更新标志
      await store.dispatch('countshow/getTeamAllDataApis')
    }

    const handleSetRead = async (scope) => {
      // // console.log(scope);
      const isRead = scope.row.isRead;
      const result = await tagMail({
        isRead: isRead === 1 ? 0 : 1,
        mailIdList: [scope.row.id],
      });
      if (result.code !== 200) {
        ElMessage.error(result.message);
        return;
      }
      tableData.value = tableData.value.map(item => {
        if (item.id === scope.row.id) {
          return {...item, isRead: isRead === 1 ? 0 : 1}
        } else {
          return item
        }
      })
      // tableData.value[scope.$index].isRead = isRead === 1 ? 0 : 1;
      // console.log(tableData.value, tableData.value[scope.$index], 'index')
      // if (sortObj.value?.orderRead !== null) {
      //   await getMailList()
      // }
      // 更新标志
      await store.dispatch('countshow/getTeamAllDataApis')
    }

    function handleSearch(val) {
      // // console.log(formLabelAlign);
      if (val === 'search') {
        isSearch.value = true
      }
      getMailList();
      drawer.value = false;
    }

    function filterReset() {
      formLabelAlign.customerName = initForm.customerName;
      formLabelAlign.customerTypeId = initForm.customerTypeId;
      formLabelAlign.isAnswer = initForm.isAnswer;
      formLabelAlign.isTrack = initForm.isTrack;
      formLabelAlign.isReply = initForm.isReply;
      formLabelAlign.rangePickerTime = initForm.rangePickerTime;
      formLabelAlign.zoneAddress = initForm.zoneAddress;
      formLabelAlign.type = 2;
      // drawer.value = false;
      nextTick(() => {
        getMailList();
      })
    }

    function tableRowClassName({row, rowIndex}) {
      return `read_${row.isRead}`;
    }

    function handleBlackSucc() {
      blackModalShow.value = false;
      setTimeout(() => {
        getMailList();
      }, 1500);
    }

    function handleBlackCancel() {
      blackModalShow.value = false;
    }

    const isClear = ref(false);
    //是否点击搜索或者高级搜索按钮,页数从1开始计算
    const isSearch = ref(false);


    function handleSearchInput(flag) {

      if (flag === "clear") {
        isClear.value = true
      } else if (flag === 'search') {
        isSearch.value = true
      } else {
        isClear.value = false
      }
      getMailList();
    }

    watch(() => teamId.value, async () => {
      console.log('组件团队ID 监听', teamId.value);
      if (teamId.value) {
        await getMailListConf();
        await getAllUserList();
        await getMailList();
      }
      configId.value = 'all';
    })

    watch(() => selectedTeamId.value, async (value, item) => {
      console.log('组件团队ID 监听', teamId.value);
      if (selectedTeamId.value !== item) {
        await getMailListConf();
        await getMailList();
        // store.dispatch("user/checkUserInfoIsAdmin", {teamId: teamId.value})
      }
    });

    watch(() => configId.value, () => {
      getMailList();
    });

    const myEmailList = computed(() => store.state.countshow.myEmailList)
    watch(() => myEmailList.value, async (value) => {
      if (myEmailList.value.map((item) => item.count).reduce((acc, val) => acc + val, 0) !== value.map((item) => item.count).reduce((acc, val) => acc + val, 0)) {
        await getMailList()
      }
    }, {immediate: true})

    const getEmailListFlag = computed(() => store.state.countshow.getEmailListFlag)

    watch(() => getEmailListFlag.value, async () => {
      await getMailList();
    })

    // 页面进行缩放
    const adjustContentPosition = debouncePlus(async () => {
      await nextTick()
      if (DragBox.value) {
        dragBoxHeight.value = DragBox.value.offsetHeight - 30;
      }
      await store.dispatch("system/getTargetHeight", {userId: activeUserId.value})
      await nextTick()
      tableRef.value?.doLayout?.()
    }, 200)

    onMounted(async () => {
      loading.value = true;
      document.addEventListener('keydown', handleKeyDown);
      document.addEventListener('keyup', handleKeyUp);
      await nextTick()
      if (DragBox.value) {
        dragBoxHeight.value = DragBox.value.offsetHeight - 30;
      }
      store.commit("sidebar/setTargetFileList", [])
      store.commit("sidebar/setPageSetting", {type: 'pageNo', value: 1})
      // elementTop.value = tableHeight.value
      store.dispatch('customer/getAreaNames')
      store.dispatch("cusList/getMailCustomerLevel", {teamId: teamId.value});
      await store.dispatch("system/getTargetHeight", {userId: activeUserId.value})
      dragControllerUD();
      await store.dispatch("sidebar/getEmailGroupFileListApis", {teamId: teamId.value, userId: activeUserId.value})
      await getAllUserList();
      if (props.group) {
        selectedFolder.value = 'all';
      }
      window.addEventListener('resize', adjustContentPosition);
    });

    onBeforeUnmount(() => {
      window.removeEventListener('resize', adjustContentPosition);
      document.removeEventListener('keydown', handleKeyDown);
      document.removeEventListener('keyup', handleKeyUp);
    });


    const close = () => {
      dialogVisible.value = false;
    }
    const closeCreated = () => {
      dialogVisibleCreatedMessage.value = false;
    }

    // 上下拖动事件
    const topBoxValue = ref(0);
    const downBoxValue = ref(0)
    // 移动
    const moveTarget = ref(null);
    const scrollBox = ref(null);
    const isDragging = ref(false);
    const initialMouseY = ref(0)
    const elementLeft = ref(0)
    const DragBox = ref()
    const dragBoxHeight = ref(0)
    const inboxTop = computed(() => {
      return topBoxValue.value !== 0 ? topBoxValue.value : store.state.system.inboxTop > dragBoxHeight.value ? dragBoxHeight.value : store.state.system.inboxTop
    })
    const inboxHeight = computed(() => store.state.system.inboxHeight)
    const elementTopRaw = ref(inboxTop.value);
    const elementTop = computed({
      get() {
        return elementTopRaw.value;
      },
      set(newValue) {
        elementTopRaw.value = newValue;
      },
    });

    const pageframeHeightRaw = ref(deviceFlag.value === 'mac' ? inboxHeight.value : inboxHeight.value + inboxHeight.value * 0.4);
    const pageframeHeight = computed({
      get() {
        return pageframeHeightRaw.value;
      },
      set(newValue) {
        pageframeHeightRaw.value = newValue;
      },
    });


    const saveTargetHeight = debouncePlus((userId, pageframeHeight, elementTop) => {
      store.dispatch("system/settingTargetHeight", {
        userId,
        inboxHeight: pageframeHeight,
        inboxTop: elementTop
      });
    }, 200); // 300ms 防抖延迟

    const sortObj = ref({})

    function sort_change({column, prop, order}) {
      console.log('ffff', column, prop, order)
      if (order != null) {
        const flag = order === 'descending' ? 2 : 1;
        // 映射排序字段到相应的请求参数
        const sortMapping = {
          isStress: 'orderStress',
          isRead: 'orderRead',
          fj: 'orderExtend',
          sendTime: 'orderTime',
          contentSize: 'orderSize'
        };

        // 获取相应的请求参数
        const requestParam = sortMapping[prop];
        sortObj.value = {[requestParam]: flag};
        console.log(sortObj.value, 'sortObj')
        if (requestParam) {
          getMailList({[requestParam]: flag});
        }
      } else {
        getMailList()
      }
    }

    // 表格内容
    const rowClassName = ({row, column, rowIndex, columnIndex}) => {
      // // console.log(row, columnIndex)
      if (props.type === 1) {
        if (columnIndex === 0 || columnIndex === 1 || columnIndex === 3 || columnIndex === 4 || columnIndex === 5 || columnIndex === 6 || columnIndex === 10) {
          return {textAlign: 'left'}
        } else {
          return {textAlign: 'center'}
        }
      } else if (props.type === 3) {
        if (columnIndex === 0 || columnIndex === 3 || columnIndex === 4 || columnIndex === 5 || columnIndex === 6 || columnIndex === 13) {
          return {textAlign: 'left'}
        } else {
          return {textAlign: 'center'}
        }
      } else if (props.type === 2) {
        if (columnIndex === 0 || columnIndex === 3 || columnIndex === 4 || columnIndex === 5 || columnIndex === 11) {
          return {textAlign: 'left'}
        } else {
          return {textAlign: 'center'}
        }
      } else if (props.type === 4) {
        if (columnIndex === 0 || columnIndex === 3 || columnIndex === 4 || columnIndex === 5 || columnIndex === 6 || columnIndex === 10) {
          return {textAlign: 'left'}
        } else {
          return {textAlign: 'center'}
        }
      }
    }

    // 表头
    const headerClassName = ({row, column, rowIndex, columnIndex}) => {
      if (props.type === 1) {
        if (columnIndex === 0 || columnIndex === 1 || columnIndex === 3 || columnIndex === 4 || columnIndex === 5 || columnIndex === 6 || columnIndex === 7 || columnIndex === 10) {
          return {'text-align': 'left',}
        } else {
          return {'text-align': 'center'}
        }
      } else if (props.type === 3) {
        if (columnIndex === 0 || columnIndex === 3 || columnIndex === 4 || columnIndex === 5 || columnIndex === 6 || columnIndex === 7 || columnIndex === 13) {
          return {'text-align': 'left',}
        } else {
          return {'text-align': 'center'}
        }
      } else if (props.type === 2) {
        if (columnIndex === 0 || columnIndex === 3 || columnIndex === 4 || columnIndex === 5 || columnIndex === 6 || columnIndex === 11) {
          return {'text-align': 'left',}
        } else {
          return {'text-align': 'center'}
        }
      } else if (props.type === 4) {
        if (columnIndex === 0 || columnIndex === 3 || columnIndex === 4 || columnIndex === 5 || columnIndex === 6 || columnIndex === 10) {
          return {'text-align': 'left',}
        } else {
          return {'text-align': 'center'}
        }
      }
    }


    const refMap = ref([])
    const tempRef = ref(null)
    const visiblePopover = ref(false)
    const popoverType = ref(0)
    const emailListCheckoutTarget = ref({remark: ''})
    const handleRef = debouncePlus((ref, item, type) => {
      tempRef.value = ref
      popoverType.value = type
      visiblePopover.value = true;
      emailListCheckoutTarget.value = item;
    }, POPOVER_DELAY_TIME)

    const hidePopoverTimeoutModel = ref(false)
    // 这里是开始点
    const mouseEnters = debouncePlus((row) => {
      // 特殊处理 不然第一次 修改后 后续触发有问题
      popoverType.value = 0
      emailListCheckoutTarget.value = row;
    }, 200)

    const mouseLeaves = () => {
      hidePopoverTimeoutModel.value = setTimeout(() => {
        visiblePopover.value = false;
      }, 300);
    }
    const keepPopoverVisibleModel = () => {
      if (hidePopoverTimeoutModel.value) {
        clearTimeout(hidePopoverTimeoutModel.value);
        hidePopoverTimeoutModel.value = null;
      }
      visiblePopover.value = true;
    }

    const hidePopoverModel = () => {
      visiblePopover.value = false;
    }

    const cancelPopover = () => {
      visiblePopover.value = false;
      emailListCheckoutTarget.value.remark = ''
    }

    // 搜索条件重制
    const resetSearchFlags = () => {
      isClear.value = true;
      searchCount.value = "";
      configId.value = "all"
    }

    const handleEditMail = (row) => {
      const query = {
        id: row.id,
        flag: row.flag,
        type: "editMail",
        mailType: props.type,
      };
      if (row.flag === 0 && row.customerId) {
        query.customerId = row.customerId;
      }
      router.push({
        path: '/email/write_mail',
        query,
      });
    }


    const computedTargetWidth = computed(() => {
      if (props.type === 1 || props.type === 3) {
        return lang.value === 'en' ? 3 * 60 : 3 * 50;
      } else if (props.type === 2) {
        return lang.value === 'en' ? 1 * 90 : 2 * 50;
      } else if (props.type === 4) {
        return lang.value === 'en' ? 2 * 60 : 2 * 50;
      }
    })


    const visibleTo = ref(false)
    const visibleCC = ref(false)

    const hidePopoverTimeout = ref(false)

    function showPopover(string = '', flag) {
      if (moveTarget.value) {
        const itemWidth = Math.round((moveTarget.value.clientWidth - 40) * (1 / 3))
        const stringWidth = string.pxWidth('normal 12px PingFangSC, PingFang SC')
        console.log(itemWidth, stringWidth)
        if (stringWidth + 10 > itemWidth) {
          if (flag === "to") {
            visibleCC.value = false;
            visibleTo.value = true;
          } else if (flag === "cc") {
            visibleTo.value = false;
            visibleCC.value = true;
          }
          if (hidePopoverTimeout.value) {
            clearTimeout(hidePopoverTimeout.value);
            hidePopoverTimeout.value = null;
          }
        }
      }
    }

    function delayedHidePopover(flag) {
      hidePopoverTimeout.value = setTimeout(() => {
        flag === "to" ? visibleTo.value = false : visibleCC.value = false;
      }, 200); // Adjust delay as necessary
    }

    function keepPopoverVisible(flag) {
      if (hidePopoverTimeout.value) {
        clearTimeout(hidePopoverTimeout.value);
        hidePopoverTimeout.value = null;
      }
      flag === "to" ? visibleTo.value = true : visibleCC.value = true;
    }

    function hidePopover(flag) {
      flag === "to" ? visibleTo.value = false : visibleCC.value = false;
    }

    // 弹窗进行编辑备注
    const visitableRemark = ref(false)
    const currentItem = ref({remark: ""})
    const handleClickRemark = (row) => {
      const {id} = row
      console.log(id, row, 'id')
      currentItem.value = row
      visitableRemark.value = true
    }
    const closeRemark = () => {
      visitableRemark.value = false
    }

    function dragControllerUD() {
      var resize = document.getElementsByClassName("move");
      var topBox = document.getElementsByClassName("topBox");
      var downBox = document.getElementsByClassName("downBox");
      var box = document.getElementsByClassName("mid");
      console.log(document.getElementsByClassName("move"), resize.length, 'resize.length');
      for (let i = 0; i < resize.length; i++) {
        // 鼠标按下事件
        resize[i].onmousedown = function (e) {
          console.log(resize[i].top);
          //颜色改变提醒
          resize[i].style.background = "#818181";
          // 100 这里是 有上面的 操作栏的高度
          var startY = e.clientY + 100;
          resize[i].top = resize[i].offsetTop;
          // 鼠标拖动事件
          document.onmousemove = function (e) {
            isDragging.value = true
            var endY = e.clientY;
            var moveLen = resize[i].top + (endY - startY); // （endY - startY）=移动的距离。resize[i].top+移动的距离=上边区域最后的高度
            var maxT = box[0].clientHeight - resize[i].offsetHeight; // 容器高度 - 上边区域的高度 = 下边区域的高度

            if (moveLen < 30) moveLen = 30; // 上边区域的最小高度为50px
            if (moveLen > maxT - 30) moveLen = maxT - 30; //下边区域最小高度为150px

            resize[i].style.top = moveLen; // 设置上边区域的高度

            for (let j = 0; j < topBox.length; j++) {
              topBox[j].style.height = moveLen + "px";
              topBoxValue.value = moveLen
              downBox[j].style.height = box[0].clientHeight - moveLen - 10 + "px";
              downBoxValue.value = box[0].clientHeight - moveLen - 10

              console.log(moveLen, box[0].clientHeight - moveLen - 10, 'mover')
              saveTargetHeight(userInfo.value.id, box[0].clientHeight - moveLen - 10, moveLen);
            }
          };
          // 鼠标松开事件
          document.onmouseup = function () {
            resize[i].style.background = "#d6d6d6";
            isDragging.value = false
            document.onmousemove = null;
            document.onmouseup = null;
            resize[i].releaseCapture && resize[i].releaseCapture();
          };

          resize[i].setCapture && resize[i].setCapture();
          return false;
        };
      }
    }

    document.onmouseup = function (e) {
      document.onmousemove = null;
      document.onmouseup = null;
    };

    // 文件夹list scroll
    const pageSetting = computed(() => store.state.sidebar.pageSetting)
    const hasMoreData = computed(() => store.getters["sidebar/hasMoreData"])
    const isLoading = ref(false)
    const handleScroll = throttle((event) => {
      const bottom = event.target.scrollHeight + 300 > event.target.scrollTop + event.target.clientHeight;
      console.log(bottom, !isLoading.value, hasMoreData.value, 'bottom && !isLoading.value && hasMoreData.value')
      if (bottom && !isLoading.value && hasMoreData.value) {
        loadMore();
      }
    }, 100)
    const loadMore = async () => {
      isLoading.value = true;
      const currentPage = Number(pageSetting.value.pageNo || 0)
      const totalPages = Number(pageSetting.value.pages || 0)
      const targetPage = currentPage + 1
      if (Number.isFinite(totalPages) && totalPages > 0 && targetPage > totalPages) {
        isLoading.value = false
        return
      }
      store.commit("sidebar/setPageSetting", {type: 'pageNo', value: targetPage})
      await store.dispatch("sidebar/getEmailGroupFileListApis", {
        teamId: teamId.value,
        userId: userInfo.value.id,
        isUpdateFileList: true
      })
      isLoading.value = false; // 加载完成
    }

    function handleReplyDetail(stringType = '', row) {
      if (!row.id) {
        return;
      }
      const query = {
        id: row.id,
        type: stringType,
        mailType: props.type,
        customerId: row.customerId
      }
      if (stringType === "") {
        delete query.type;
      }
      console.log(query, 'payload')
      // router.push({
      //   path: '/email/write_mail',
      //   query,
      // });
      // 构造 query 参数字符串
      const queryString = new URLSearchParams(query).toString();
      // 拼接完整 URL（假设是 hash 模式或 history 模式可视项目结构调整）
      const url = `${location.origin}/email/write_mail?${queryString}`;
      // 在新标签页打开
      window.open(url, '_blank');
    }


    const openNewWindow = (url) => {
      window.open(url, "_blank");
    };

    const handleClickToLinkCustomerDetail = (customerId) => {
      openNewWindow('/email/customer/detail/' + customerId + '?type=1')
    }

    const showLogError = ref('')
    // const logErrorLoading = ref('')
    const handleShowPopover = async (item) => {
      console.log(item, 'item')
      try {
        const payload = {
          mailId: item.id
        }
        // logErrorLoading.value = i18n.global.t('common.loading.list')
        const res = await getEmailLog(payload)
        showLogError.value = res.result?.failTranslate
        // logErrorLoading.value = ''
      } catch (e) {
        // logErrorLoading.value = ''
      }
    }

    return {
      showLogError,
      handleShowPopover,
      handleClickToLinkCustomerDetail,
      openNewWindow,
      deleteLoading,
      handleReplyDetail,
      DragBox,
      isLoading,
      loadMore,
      handleScroll,
      topBoxValue,
      downBoxValue,
      currentItem,
      closeRemark,
      visitableRemark,
      handleClickRemark,
      selectedFolder,
      props,
      handleGroupEmail,
      fileList,
      hidePopoverModel,
      keepPopoverVisibleModel,
      showPopover,
      delayedHidePopover, keepPopoverVisible, hidePopover,
      visibleTo,
      visibleCC,
      lang,
      computedTargetWidth,
      handleEditMail,
      popoverType,
      refMap,
      tempRef,
      detailLoading,
      cancelPopover,
      mouseLeaves,
      mouseEnters,
      emailListCheckoutTarget,
      visiblePopover,
      handleRef,
      visiblePop,
      handleResend,
      headerClassName,
      rowClassName,
      sort_change,
      getMailList,
      createdNewCustomer,
      emailsReturn,
      activeItemRow,
      close,
      closeCreated,
      deleteAll,
      pageframeHeight,
      elementLeft,
      elementTop,
      scrollBox,
      moveTarget,
      configId,
      emailList,
      tableData,
      current,
      size,
      total,
      loading,
      multipleTableRef,
      inboxRef,
      tableHeight,
      tableRef,
      drawer,
      direction,
      labelPosition,
      formLabelAlign,
      tableDataLevel,
      areaList,
      iframeContent,
      tableDataSelect,
      selectedTeamId,
      blackModalShow,
      multipleSelection,
      searchCount,
      handleCommand,
      currentMail,
      tableRowClassName,
      handleViewDetail,
      handleReply,
      handleSetRead,
      handleSearch,
      handleSearchInput,
      filterReset,
      handleDownload,
      handleCurrentChange,
      handleCurrentRowChange,
      handleSettingStress,
      handleSelectionChange,
      requestTagAllRead,
      requestDelMail,
      handleBlack,
      handleEdit,
      formatText,
      handleBlackSucc,
      handleBlackCancel,
      dialogVisible,
      dialogVisibleCreatedMessage,
      forms,
      options,
      optionsCustomers,
      contactPerson,
      contactList,
      removeEmail,
      ruleForm,
      form,
      dialogVisibleDelete,
      emptyUrl,
      route,
      handleSelectUser,
      handleSelectFolder,
      targetFileList,
      isDragging,
      inboxHeight,
      inboxTop,
      pageframeHeightRaw,
      elementTopRaw,
      deviceFlag,
    }
  }
}
</script>


<style lang="less">
.el_modal {
  .el-drawer__header {
    margin-bottom: 0px;
    //padding-bottom: 20px;
    border-bottom: 1px solid #e8e8e8;
  }
}
</style>
<style lang="less" scoped>
@import "../../Customer/less/detail.less";
@import "./index.less";

.up_row, .down_row {
  width: 100%;
  height: 2px !important;
  cursor: row-resize !important;
}

.flex {
  height: 100%;
  width: 100%;
  display: flex;
  justify-content: center;
  align-items: center
}

.over_text {
  color: black !important;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
  line-height: 26px;
  width: 33.33%;
  text-align: left;
}

#pageframe {
  background: transparent;
}

iframe {
  opacity: 0;
  transition: opacity 0.5s ease-in-out;
}

iframe.loaded {
  opacity: 1;
}

:deep(.el-popper) {
  max-width: 45% !important;
}

.el-popover.el-popper.visible {
  max-width: 300px !important;
}

.el-popover.el-popper.sp_model_popover {
  max-width: 300px !important;
}

.visible {
  padding: 0px !important;

  & > div {
    margin: -12px !important;
    padding: 8px !important;
  }
}

.sp_model_popover {
  padding: 0px !important;

  & > div {
    margin: -12px !important;
    padding: 12px !important;
  }
}

#sp_tables {
  position: relative;

  :deep(.el-table__header) {
    width: 100% !important;
  }

  :deep(.el-table__body) {
    width: 100% !important;
  }
}

:deep(.el-scrollbar__bar.is-horizontal) {
  height: 6px !important;
}

:deep(.el-table__inner-wrapper:before) {
  background: transparent !important;
}

:deep(.sp_email .el-input__wrapper) {
  background: #f5f7fa !important;
}

:deep(.el-input__wrapper) {
  min-height: 0px !important;
}

.Drag2 {
  height: calc(100vh - 146px);
}

/*包围div样式*/
.box {
  width: 100%;
  height: 100%;
  margin: 0.1% 0px;
  overflow: hidden;
  box-shadow: -1px 9px 10px 3px rgba(0, 0, 0, 0.11);
}

/*左侧div样式*/
.left {
  width: calc(32% - 10px); /*左侧初始化宽度*/
  height: 100%;
  background: #71ad88;
  float: left;
}

/* 拖拽区div样式 */
.resize {
  cursor: w-resize;
  float: left;
  position: relative;
  top: 45%;
  background-color: #d6d6d6;
  border-radius: 5px;
  margin-top: -10px;
  width: 10px;
  height: 50px;
  background-size: cover;
  background-position: center;
  /*z-index: 99999;*/
  font-size: 32px;
  color: white;
}

/*拖拽区鼠标悬停样式*/
//.movers:hover {
//  color: #444444;
//}

/*右侧div'样式*/
.mid {
  float: left;
  width: 100%; /*右侧初始化宽度*/
  height: 100%;
  background: #f3f3f3;
  box-shadow: -1px 4px 5px 3px rgba(0, 0, 0, 0.11);
  /*上方div'样式*/

  .topBox {
    height: 60%;
    background-color: #3ff53f;
    display: flex;
  }

  /*下方div'样式*/

  .downBox {
    //height: calc(40% - 32px);
    background-color: white;
    display: flex;
  }

  /* 拖拽区div样式 */

  .mover {
    padding: 0px 20px;
    //cursor: s-resize;
    cursor: text;
    width: 100%;
    height: 30px;
    background-color: #d6d6d6;
    border-radius: 5px;
    text-align: center;
    line-height: 3px;
    font-size: 12px;
    user-select: text; /* 启用文本选择 */
  }

  /*拖拽区鼠标悬停样式*/

  .mover:hover {
    color: #444444;
  }
}

#pageframe {
  padding-bottom: 30px;
}

:deep(.el-checkbox__inner::after) {
  top: 1px !important;
  left: 4px !important;
}

//
.move-select {
  .dropdown-menu-wrapper {
    min-width: auto !important;
    width: auto;
    max-width: 200px !important;
    overflow: hidden;
    white-space: nowrap;
    text-overflow: ellipsis;
  }

  :deep(.el-dropdown-menu__item) {
    min-width: auto !important;
    width: auto;
    max-width: 200px !important;
    overflow: hidden;
    white-space: nowrap;
    text-overflow: ellipsis;
    display: inherit !important;
  }
}

.customer-level .el-select-dropdown__item {
  max-width: 100% !important;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}

.inner_select {
  width: auto;
  max-width: 300px;
  overflow: hidden;
  white-space: nowrap;
  text-overflow: ellipsis;
}

:deep(.el-drawer__header) {
  padding-bottom: 10px !important;
}

.inners_warning {
  display: flex;
  flex-direction: column !important;
  justify-content: center !important;
  align-items: center !important;
}

.setting_center {
  display: flex !important;
  justify-content: center !important;
}

:deep(.el-select--small .el-select__wrapper) {
  font-size: 13px !important;
}

:deep(.el-input__inner) {
  font-size: 13px !important;
}

.tooltip-content-wrap {
  max-width: 300px;
  max-height: 200px;
  overflow-y: auto;
  white-space: normal;
  word-break: break-word;
  padding: 4px;
}

.urgent-icon {
  width: 15px;
  height: 15px;
  position: relative;
  top: 3px;
}

.tooltip-content-wrap {
  max-width: 300px;
  max-height: 200px;
  overflow-y: auto;
  white-space: normal;
  word-break: break-word;
  padding: 4px;
}

:deep(.el-drawer__header){
  color:rgba(0, 0, 0, 0.85) !important;
}
</style>
